import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.array.some-0c761b6d.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.keys-9d66766f.js";
import "./es.object.to-string-f55666a8.js";
import f, { useRef as v, useState as L, useEffect as S } from "react";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./array-method-is-strict-e5a3c878.js";
import "./iterate-13ada9e5.js";
import "./classof-21a3574e.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
var n = /* @__PURE__ */ function(a) {
  return a.ALL = "all", a.LAST = "last", a.FIRST = "first", a;
}({}), p = function(u, o, t) {
  t === void 0 && (t = n.ALL);
  var e = {
    rest: []
  };
  return Object.keys(o).forEach(function(r) {
    e[r] = [];
  }), f.Children.forEach(u, function(r) {
    if (!/* @__PURE__ */ f.isValidElement(r))
      return r && e.rest.push(r);
    var m = Object.keys(o).find(function(i) {
      var s = o[i];
      return Array.isArray(s) ? s.some(function(c) {
        return r.type === c;
      }) : r.type === s;
    });
    (m ? e[m] : e.rest).push(r);
  }), Object.fromEntries(Object.entries(e).map(function(r) {
    var m = r[0], i = r[1];
    return [m, m !== "rest" && t !== n.ALL ? t === n.FIRST ? i.at(0) : i.at(-1) : i];
  }));
}, A = function(u, o, t) {
  o === void 0 && (o = {}), t === void 0 && (t = n.ALL);
  var e = v(o), r = L(p(u, o, t)), m = r[0], i = r[1];
  return S(function() {
    i(p(u, e.current, t));
  }, [u, t]), m;
};
A.PickType = n;
export {
  n as UseSlotsPickType,
  p as createSlots,
  A as useSlots
};
